import { formatInstance } from 'models/formatters'
import { SHIPPING_BEFORE_CREATE_HOOK } from 'modules/shipping/hooks/before-create'

const FORMATTER_MAP = {
  ...SHIPPING_BEFORE_CREATE_HOOK
}

function formatInstanceBeforeCreate (params) {
  return formatInstance({
    ...params,
    formatterMap: FORMATTER_MAP
  })
}

export {
  formatInstanceBeforeCreate
}
